export const COLUMN_HEADER_HEIGHT = 48;
export const COLUMN_HEIGHT = 40;
